var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSarSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10.7568,
    height: 12,
    viewBox: "0 0 10.7568 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2182",
    d: "M6.31494 1.67203C6.77132 1.17501 7.05073 0.942106 7.58589 0.624997V7.7211L10.7498 7.07C10.7151 7.38497 10.6813 7.51873 10.6201 7.74749C10.5588 7.97626 10.5008 8.16555 10.3874 8.42059L6.31494 9.26966V1.67203Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2183",
    d: "M5.06217 0C4.40432 0.378273 4.29244 0.51912 3.79251 1.02059V8.83823L0.363235 9.56412C0.175278 9.88967 -0.0126798 10.8927 0.000745723 10.9103C0.0141713 10.9279 3.61988 10.136 3.72857 10.136C3.93934 10.0393 4.07316 9.98205 4.21636 9.81048C4.35957 9.63891 4.54753 9.35295 4.54753 9.35295L4.91002 8.80744C5.01928 8.65353 5.05483 8.56066 5.06217 8.3807V0Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2184",
    d: "M0.965659 6.66869L10.7568 4.59763C10.6605 5.20352 10.576 5.50319 10.3764 5.97088L0.60319 8.04193C0.672447 7.52471 0.727936 7.23059 0.965659 6.66869Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2185",
    d: "M6.6759 10.6086L10.7521 9.76753C10.6742 10.3338 10.5965 10.6357 10.3852 11.141L6.30452 11.9999C6.39642 11.4617 6.47901 11.1594 6.6759 10.6086Z",
    fill: "#030F1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSarSm);
export default __webpack_public_path__ + "static/media/sar-sm.d36cdb65c4ae4967f71d2246f3041d7a.svg";
export { ForwardRef as ReactComponent };